/**
 * Build-time constants surfaced to user-facing legal & static pages.
 * Centralised here so a single import keeps marketing + App Store copy
 * + the in-app /privacy route in sync.
 *
 * NOTE: bump PRIVACY_LAST_UPDATED whenever the policy text materially
 * changes. The PrivacyPage renders it verbatim in the "Last updated" line.
 */
export const PRIVACY_LAST_UPDATED = "February 13, 2026";
export const TERMS_LAST_UPDATED = "February 14, 2026";

export const SUPPORT_EMAIL = "support@daione.app";
export const PRIVACY_EMAIL = "support@daione.app";
